import axios from 'axios'
import Vue from 'vue'

var http = null

class WebService {
  constructor({
    url
  }) {
    http = axios.create({ baseURL: url })
  }

  getAPI({
    _action,
    _body,
    _buttonId,
    _hide_loader,
    _clear_cache,
  }) {
    let params = new URLSearchParams()
    for (let key in _body) {
      params.set(key, _body[key])
    }

    this.addLoader(_buttonId, _hide_loader)

    return http
      .get(_action, {
        params: params,
        headers: this.getHeader()
      })
      .then(response => {
        this.removeLoader(_buttonId, _hide_loader)
        return response.data
      })
      .catch(e => {
        this.removeLoader(_buttonId, _hide_loader)
        return Promise.resolve(this._errorHandler(e))
      })
  }

  getAndDownloadAPI({
    _action,
    _body,
    _buttonId,
    _hide_loader,
    _fileName
  }) {
    let params = new URLSearchParams()
    for (let key in _body) {
      params.set(key, _body[key])
    }

    this.addLoader(_buttonId, _hide_loader)

    return http
      .get(_action, {
        params: params,
        headers: this.getHeader()
      })
      .then(response => {
        this.removeLoader(_buttonId, _hide_loader)
        var blob = new Blob([response.data]);
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = _fileName;
        link.click();
      })
      .catch(e => {
        this.removeLoader(_buttonId, _hide_loader)
        return this._errorHandler(e)
      })
  }

  postAPI({
    _action,
    _body,
    _buttonId,
    _hide_loader
  }) {
    this.addLoader(_buttonId, _hide_loader)
    return http
      .post(_action, JSON.stringify(_body), {
        headers: this.getHeader()
      })
      .then(response => {
        this.removeLoader(_buttonId, _hide_loader)
        return response.data
      })
      .catch(e => {
        this.removeLoader(_buttonId, _hide_loader)
        return Promise.resolve(this._errorHandler(e))
      })
  }

  putAPI({
    _action,
    _body,
    _buttonId,
    _hide_loader
  }) {
    this.addLoader(_buttonId, _hide_loader)
    return http
      .put(_action, JSON.stringify(_body), {
        headers: this.getHeader()
      })
      .then(response => {
        this.removeLoader(_buttonId, _hide_loader)
        return response.data
      })
      .catch(e => {
        this.removeLoader(_buttonId, _hide_loader)
        return Promise.resolve(this._errorHandler(e))
      })
  }

  patchAPI({
    _action,
    _body,
    _buttonId,
    _hide_loader
  }) {
    this.addLoader(_buttonId, _hide_loader)
    return http
      .patch(_action, JSON.stringify(_body), {
        headers: this.getHeader()
      })
      .then(response => {
        this.removeLoader(_buttonId, _hide_loader)
        return response.data
      })
      .catch(e => {
        this.removeLoader(_buttonId, _hide_loader)
        return Promise.resolve(this._errorHandler(e))
      })
  }

  deleteAPI({
    _action,
    _buttonId,
    _hide_loader
  }) {
    this.addLoader(_buttonId, _hide_loader)
    return http
      .delete(_action, {
        headers: this.getHeader()
      })
      .then(response => {
        this.removeLoader(_buttonId, _hide_loader)
        return response.data
      })
      .catch(e => {
        this.removeLoader(_buttonId, _hide_loader)
        return Promise.resolve(this._errorHandler(e))
      })
  }

  getAccesstoken({
    _action,
    _body,
    _buttonId,
    _hide_loader
  }) {
    this.addLoader(_buttonId, _hide_loader)
    var headers = {}

    headers['Content-Type'] = 'application/json'

    return http
      .post(_action, JSON.stringify(_body), {
        headers: headers
      })
      .then(response => {
        this.removeLoader(_buttonId, _hide_loader)
        return response.data
      })
      .catch(e => {
        this.removeLoader(_buttonId, _hide_loader)
        return this._loginErrorHandler(e)
      })
  }

  uploadImageAPI({
    _action,
    _file,
    _key,
    _body,
    _buttonId,
    _hide_loader
  }) {
    if (!_key) {
      _key = 'file'
    }
    this.addLoader(_buttonId, _hide_loader)
    let formData = new FormData()

    formData.append(_key, _file)
    for (let key in _body) {
      formData.append(key, _body[key])
    }

    return http
      .post(_action, formData, {
        headers: this.addHeaderForMultipart()
      })
      .then(response => {
        this.removeLoader(_buttonId, _hide_loader)
        return response.data
      })
      .catch(e => {
        this.removeLoader(_buttonId, _hide_loader)
        return Promise.resolve(this._errorHandler(e))
      })
  }

  uploadImageAPIAsPatch({
    _action,
    _file,
    _key,
    _body,
    _buttonId,
    _hide_loader
  }) {
    if (!_key) {
      _key = 'file'
    }
    this.addLoader(_buttonId, _hide_loader)
    let formData = new FormData()

    formData.append(_key, _file)
    for (let key in _body) {
      formData.append(key, _body[key])
    }

    return http
      .patch(_action, formData, {
        headers: this.addHeaderForMultipart()
      })
      .then(response => {
        this.removeLoader(_buttonId, _hide_loader)
        return response.data
      })
      .catch(e => {
        this.removeLoader(_buttonId, _hide_loader)
        return Promise.resolve(this._errorHandler(e))
      })
  }

  _loginErrorHandler(error) {
    if (error.response != null) {
      error = error.response
    }
    var errorMessage;
    if (!!error.isAxiosError && !error.response) {
      errorMessage = 'Server Not Responding'
    } else if (error.status == 400 || error.status == 404) {
      errorMessage =
        (error && error.data && error.data.message) ||
        'Invalid Username or Password'
    } else if (error.status == 500) {
      errorMessage = 'Server Error'
    } else {
      errorMessage =
        error.data.message || 'Bad Response'
    }

    Vue.notify({
      group: 'foo',
      text: errorMessage,
      type: "error"
    })


    throw new Error(errorMessage)
  }

  _errorHandler(error) {
    if (error.response != null) {
      error = error.response
    }
    var errorMessage;
    if (!!error.isAxiosError && !error.response) {
      errorMessage = 'Server Not Responding'
    } else if (error.status == 401) {
      errorMessage =
          (error && error.data && error.data.message) || 'Bad Response'
        this.logout()
    } else if (error.status == 500) {
      errorMessage = 'Server Error'
    } else if (error.status == 400) {
      errorMessage = error.data.message || 'Bad Response'
    } else {
      throw error
    }

    Vue.notify({
      group: 'foo',
      text: errorMessage,
      type: "error"
    })

    throw new Error(errorMessage)
  }

  logout() {
    localStorage.clear();
    this.$shareService.clearMap();
    window.location.href = "/login"
  }

  getHeader() {
    var headers = {}
    headers['Content-Type'] = 'application/json'
    const urlParams = new URLSearchParams(window.location.search)
    headers['Accept-Language'] = urlParams.get('lang') ? urlParams.get('lang') : (localStorage.getItem('locale') || 'en')
    if (localStorage.getItem('access_token')) {
      headers['Authorization'] = 'Bearer ' + localStorage.getItem('access_token')
    }
    return headers
  }

  addHeaderForMultipart() {
    if (localStorage.getItem('access_token')) {
      var headers = {}
      if (localStorage.getItem('access_token')) {
        headers['Authorization'] = 'Bearer ' + localStorage.getItem('access_token')
      }
      return headers
    } else {
      // logout app
    }
  }

  addLoader(id, _hide_loader) {
    if (id) {
      var button = document.getElementById(id)
      button.disabled = true
      var loader = document.createElement('i')
      loader.className = 'fa fa-spinner fa-spin mr-2'
      button.prepend(loader)
    }
    if (!_hide_loader) {
      const urlParams = new URLSearchParams(window.location.search)
      const lang = urlParams.get('lang') ? urlParams.get('lang') : (localStorage.getItem('locale') || 'en')
      if (lang == 'id') {
        this.ajaxindicatorstart("Memuat...Harap Tunggu...!!!")
      }
      else {
        this.ajaxindicatorstart("Loading...Please Wait...!!!")
      }
    }
  }

  removeLoader(id, _hide_loader) {
    if (id) {
      var button = document.getElementById(id)
      button.disabled = false
      button.removeChild(button.childNodes[0])
    }
    if (!_hide_loader) {
      this.ajaxindicatorstop()
    }
  }

  ajaxindicatorstart(text) {
    if ($('body').find('#resultLoading').attr('id') != 'resultLoading') {
      $('body')
        .append(
          "<div id='resultLoading' style='display:none'><div><img width='50px' src='/images/ajax-loader2.gif'><div>" +
          text +
          "</div></div><div class='bg'></div></div>");
    }

    $('#resultLoading').css({
      'width': '100%',
      'height': '100%',
      'position': 'fixed',
      'z-index': '10000000',
      'top': '0',
      'left': '0',
      'right': '0',
      'bottom': '0',
      'margin': 'auto'
    });

    $('#resultLoading .bg').css({
      'background': '#000000',
      'opacity': '0.05',
      'width': '100%',
      'height': '100%',
      'position': 'absolute',
      'top': '0'
    });

    $('#resultLoading>div:first').css({
      'width': '250px',
      'height': '75px',
      'text-align': 'center',
      'position': 'fixed',
      'top': '0',
      'left': '0',
      'right': '0',
      'bottom': '0',
      'margin': 'auto',
      'font-size': '16px',
      'z-index': '10',
      'color': '#3c2781'
    });

    $('#resultLoading .bg').height('100%');
    $('#resultLoading').fadeIn(300);
    $('body').css('cursor', 'wait');
  }

  ajaxindicatorstop() {
    $('#resultLoading .bg').height('100%');
    $('#resultLoading').fadeOut(300);
    $('body').css('cursor', 'default');
  }
}

export default new WebService({
  url: process.env.VUE_APP_API_ENDPOINT
})
